export const LineChartLoading = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 509 266"
      preserveAspectRatio="xMidYMid meet"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <style>
        {`
          @keyframes pulse {
            0% { opacity: 0.3; }
            50% { opacity: 0.7; }
            100% { opacity: 0.3; }
          }
          .loading-element {
            animation: pulse 1.5s ease-in-out infinite;
          }
        `}
      </style>
      <path
        className="loading-element"
        d="M31 220H508"
        stroke="#ECEFF3"
        strokeLinecap="round"
        strokeDasharray="2 2"
      />
      <path
        className="loading-element"
        d="M31 179L508 178"
        stroke="#ECEFF3"
        strokeLinecap="round"
        strokeDasharray="2 2"
      />
      <path
        className="loading-element"
        d="M31 136H508"
        stroke="#ECEFF3"
        strokeLinecap="round"
        strokeDasharray="2 2"
      />
      <path
        className="loading-element"
        d="M31 94H508"
        stroke="#ECEFF3"
        strokeLinecap="round"
        strokeDasharray="2 2"
      />
      <path
        className="loading-element"
        d="M31 52H508"
        stroke="#ECEFF3"
        strokeLinecap="round"
        strokeDasharray="2 2"
      />
      <path
        className="loading-element"
        d="M31 10H508"
        stroke="#ECEFF3"
        strokeLinecap="round"
        strokeDasharray="2 2"
      />
      <rect className="loading-element" width="19" height="19" rx="3" fill="#ECEFF3" />
      <rect className="loading-element" y="42" width="19" height="19" rx="3" fill="#ECEFF3" />
      <rect className="loading-element" y="84" width="19" height="19" rx="3" fill="#ECEFF3" />
      <rect className="loading-element" y="126" width="19" height="19" rx="3" fill="#ECEFF3" />
      <rect className="loading-element" y="168" width="19" height="19" rx="3" fill="#ECEFF3" />
      <rect className="loading-element" y="210" width="19" height="19" rx="3" fill="#ECEFF3" />
      <rect
        className="loading-element"
        x="31"
        y="247"
        width="32"
        height="19"
        rx="3"
        fill="#ECEFF3"
      />
      <rect
        className="loading-element"
        x="120"
        y="247"
        width="32"
        height="19"
        rx="3"
        fill="#ECEFF3"
      />
      <rect
        className="loading-element"
        x="209"
        y="247"
        width="32"
        height="19"
        rx="3"
        fill="#ECEFF3"
      />
      <rect
        className="loading-element"
        x="298"
        y="247"
        width="32"
        height="19"
        rx="3"
        fill="#ECEFF3"
      />
      <rect
        className="loading-element"
        x="387"
        y="247"
        width="32"
        height="19"
        rx="3"
        fill="#ECEFF3"
      />
      <rect
        className="loading-element"
        x="476"
        y="247"
        width="32"
        height="19"
        rx="3"
        fill="#ECEFF3"
      />
      <path
        className="loading-element"
        d="M49 165L136 158.5L226 122.5L314 142.5L403 122.5L492 142.5"
        stroke="#ECEFF3"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle
        className="loading-element"
        cx="47"
        cy="165"
        r="3"
        fill="white"
        stroke="#ECEFF3"
        strokeWidth="2"
      />
      <circle
        className="loading-element"
        cx="136"
        cy="158"
        r="3"
        fill="white"
        stroke="#ECEFF3"
        strokeWidth="2"
      />
      <circle
        className="loading-element"
        cx="226"
        cy="122"
        r="3"
        fill="white"
        stroke="#ECEFF3"
        strokeWidth="2"
      />
      <circle
        className="loading-element"
        cx="314"
        cy="142"
        r="3"
        fill="white"
        stroke="#ECEFF3"
        strokeWidth="2"
      />
      <circle
        className="loading-element"
        cx="403"
        cy="122"
        r="3"
        fill="white"
        stroke="#ECEFF3"
        strokeWidth="2"
      />
      <circle
        className="loading-element"
        cx="492"
        cy="143"
        r="3"
        fill="white"
        stroke="#ECEFF3"
        strokeWidth="2"
      />
    </svg>
  );
};
